import { useAuthSync } from './hooks/useAuthSync';

export const AuthSyncMonitor = () => {
  useAuthSync();
  return null;
};
